module.exports = __webpack_public_path__ + "img/service_kyusyu_atm_network_pc.6dae64fd.svg";